import { Box } from "@mui/material";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimeField } from "@mui/x-date-pickers/TimeField";
import { DateTime } from "luxon";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { NUMERIC_FIELD_WIDTH, TEXT_FIELD_WIDTH } from "../../../theme/tokens";
import { DateInput } from "../../UIToolkit/Inputs/DateInput";

type Props = { value: DateTime; onChange: (value: DateTime) => void };

/**
 * When the staff member called in — a date (never in the future) and a 24-hour time, recorded on every shift
 * the call-in reason removes. Moved unchanged from the Remove Staff footer's inline fields.
 */
export const CallInTimeField: FC<Props> = ({ value, onChange }) => {
	const { t } = useTranslation();
	return (
		<Box sx={{ display: "flex", gap: 2, alignItems: "center" }} data-testid="call-in-time-input">
			<DateInput
				label={t("call.in.time.label")}
				value={value}
				onChange={(next) => onChange(value.set({ year: next.year, month: next.month, day: next.day }))}
				maxDate={DateTime.now()}
				formControlSx={{ minWidth: TEXT_FIELD_WIDTH.PAIRED_MIN }}
			/>
			<LocalizationProvider dateAdapter={AdapterLuxon}>
				<TimeField
					label={t("call.in.time.time.label")}
					value={value}
					onChange={(next) => next?.isValid && onChange(value.set({ hour: next.hour, minute: next.minute }))}
					format="HH:mm"
					sx={{ width: NUMERIC_FIELD_WIDTH.CLOCK }}
				/>
			</LocalizationProvider>
		</Box>
	);
};
